<template>
    <ul>
        <div :style="{'margin-top':top+'px'}">
            <li v-for="(item,key) in resList" v-bind:key="key">
                <div class="img-box">
                    <img v-lazy="'http://'+item.image.host +'/'+ item.image.path +'/'+item.image.name+'.'+item.image.suffix" alt="">
                </div>
                <span>{{item.content}}</span>
            </li>
        </div>
    </ul>
</template>

<script>
/**
 * 播报组件
 */
import {
    Swipe,
    SwipeItem,
    Indicator,
    Toast,
    Lazyload,
    InfiniteScroll
} from "mint-ui";
import {
    API_GET,
    API_POST,
    getLocation,
    getToken,
    API_POST_TOKEN,
    clearToken,
    GET_DICT,
    getUnionId,
    WWW
} from "@/apiConfig";

export default {
    name: "ReportList",

    data() {
        return {
            WWW,
            resList: [],
            top: 0,
            time: null
        };
    },

    created() {},

    mounted() {
        this.fetchReports();
        
    },

    beforeDestroyd() {
        this.time = null;
    },

    methods: {
        fetchReports: function() {
            /**
             * 获取预约播报
             */
            API_POST(
                "https://user.lianlianche.com/report/getReports",
                { type: 0 },
                true
            ).then(res => {
                if (res.status == 0) {
                    let That = this;
                    this.resList = res.data;
                    this.time = window.setInterval(() => {
                        console.log(this.resList, "res获取预约播报");
                        if (this.resList.length == 0) {
                            window.clearInterval(this.time);
                        }
                        That.top = That.top - 1;
                        if (-That.top >= this.resList.length * 34) {
                            That.top = 0;
                        }
                    }, 100);
                } 
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/ReportListComponent.vue